/* eslint-disable react/no-array-index-key */
import React from 'react';
import { connect } from 'react-redux';

import { I18n } from 'react-redux-i18n';
import { getFreight } from '../../../app/store/actions/cart';
import PriceComponent from '../../price/Price';

class Freight extends React.PureComponent {
  state = {
    message: '',
  }

  async componentDidMount() {
    try {
      await this.props.getFreight();
    } catch (err) {
      const validError = !!(err.response && err.response.data && err.response.data.error);
      const details = validError && err.response.data.error.details;
      await this.setState({ message: `${I18n.t('errorOcurred')} - ${details}` });
    }
  }

  render() {
    const { message } = this.state;
    const {
      location, freights,
    } = this.props;

    return (
      <div
        className="basket-card active"
        style={{
          MozBorderRadius: '6px',
          borderRadius: '6px',
          boxShadow: 'unset',
          marginTop: 20,
        }}
      >
        <div
          className="card checkout-payment-card"
        >
          <span>{I18n.t('checkoutSelectFreigth')}</span>
        </div>

        {freights && freights.map((freight, indexF) => (
          <div key={`${freight.shippingCompanyName}${indexF}`} className="basket-invoice">
            <div
              className="invoice"
              style={{
                width: '100%', cursor: 'pointer', boxShadow: '0 0 3px rgba(5,8,0,.72)', height: '120px',
              }}
              onClick={() => this.props.setFreight(location, freight)}
              role="presentation"
            >
              <div className="row address-sub-card">
                {`${I18n.t('transportCompany')}: ${freight.shippingCompanyName}`}
              </div>
              <div className="row address-sub-card">
                {`${I18n.t('transportDocument')}: ${freight.shippingCompanyDoc}`}
              </div>
              <div className="row address-sub-card">
                {`${I18n.t('timeDelivered')}: ${freight.deadline} ${I18n.t('days')}`}
              </div>
              <div className="row address-sub-card-freightvalue">
                <PriceComponent value={freight.value} />
              </div>
            </div>
          </div>
        ))}

        {message && <p className="error-msg">{message}</p>}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  freights: state.cart && state.cart.freight,
});

const mapDispatchToProps = dispatch => ({
  getFreight: () => dispatch(getFreight()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Freight);
